import { type FC } from 'react';

import { ServicePeriodItem } from '@/components/AdvertisePayments/components/ExtraContent/ExtraContent.types';
import { ModalExtraContentServicePeriodListItem } from '@/components/AdvertisePayments/components/ExtraContent/ServicePeriodListItem';

import * as S from './ExtraContent.styles';

type ModalExtraContentServicePeriodListProps = {
  activePeriodId: number | null;
  periodItems: ServicePeriodItem[];
  onSelect: (id: number) => void;
};

export const ModalExtraContentServicePeriodList: FC<
  ModalExtraContentServicePeriodListProps
> = ({ activePeriodId, periodItems, onSelect }) => {
  return (
    <S.PlanOptionsRow>
      {periodItems.map(periodItem => (
        <ModalExtraContentServicePeriodListItem
          key={periodItem.id}
          isActiveCard={activePeriodId === periodItem.id}
          onSelect={() => onSelect(periodItem.id)}
          periodItem={periodItem}
        />
      ))}
    </S.PlanOptionsRow>
  );
};
